/**
 * Il glifo del rango, in forma: la stessa geometria dei caratteri della scala
 * (● ◆ ▲ ▲▲), cosi' che la legenda in testo e il segno sulla tela si
 * riconoscano l'uno nell'altro. La forma dice quanto il tono: rombo, triangolo
 * e doppio triangolo si distinguono anche stampati in bianco e nero.
 */
import { RANKS, UNRANKED, type Rank } from '../design/scales'

/** I ranghi che hanno un livello di specifica, dal piu' grave. S1 e S0 non
 *  si segnano — nessuna anomalia si dichiara a quei ranghi. */
export const DRAWN: Rank[] = [4, 3, 2]
  .map((rank) => RANKS[rank])
  .filter((one): one is Rank => one !== undefined)

export function RankGlyph({ rank, x, y, scale = 1 }: { rank: Rank; x: number; y: number; scale?: number }): JSX.Element {
  const fill = `var(--${rank.tone})`
  const r = 2.2 * scale
  const w = 0.7 * scale
  if (rank.name === 'S4') {
    return (
      <>
        <polygon
          points={`${x},${y - r - 1.4 * scale} ${x + r + 1.2 * scale},${y + r} ${x - r - 1.2 * scale},${y + r}`}
          fill="none"
          stroke={fill}
          strokeWidth={w}
        />
        <polygon
          points={`${x},${y - r + 0.4 * scale} ${x + r - 0.6 * scale},${y + r - 0.6 * scale} ${x - r + 0.6 * scale},${y + r - 0.6 * scale}`}
          fill={fill}
        />
      </>
    )
  }
  if (rank.name === 'S3') {
    return <polygon points={`${x},${y - r - 0.4 * scale} ${x + r},${y + r - 0.4 * scale} ${x - r},${y + r - 0.4 * scale}`} fill={fill} />
  }
  if (rank.name === 'S2') {
    return <polygon points={`${x},${y - r} ${x + r},${y} ${x},${y + r} ${x - r},${y}`} fill={fill} />
  }
  if (rank === UNRANKED) {
    return <circle cx={x} cy={y} r={r - 0.5 * scale} fill="none" stroke={fill} strokeWidth={0.6 * scale} strokeDasharray="1 0.8" />
  }
  return <circle cx={x} cy={y} r={r - 0.4 * scale} fill={fill} />
}
